import React, {useState} from "react";
import {capitalize, Tooltip} from "@mui/material";
import Box from "@mui/material/Box";

export default function RoundEndIcon(props: {round_end: string | undefined, sx? :any}){
    const [src, setSrc] = useState(
        `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${30},w_${30}/valWebp/${props.round_end}.webp`
    );

    const handleImageError = () => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${30},w_${30}/v1/teamsLogo/Boa.png`); // Replace with the path to your placeholder image
    };
    return <Tooltip title={capitalize(props.round_end ? props.round_end : 'undefined')} followCursor={true}>
        <Box
                component={"img"}
                src={src}
                onError={() => handleImageError()}
                sx={props.sx}
            />
        </Tooltip>
}